import React, { createContext, useCallback, useState, useContext } from 'react';
import { Cookies } from 'react-cookie';

interface UserData {
  uid: string;
  email: string;
  name: string;
  avatar: string | null;
  instance_name?: string;
}

interface AuthState {
  user: UserData;
}

export interface SignUpData {
  name: string;
  email: string;
  password: string;
  password_confirmation: string;
}

interface AdminAuthContextData {
  user: UserData;
  signOut(): void;
  updateUser(user: UserData): void;
}

const cookies = new Cookies();
const { REACT_APP_APP_NAME } = process.env;

const AdminAuthContext = createContext<AdminAuthContextData>(
  {} as AdminAuthContextData,
);

export const AdminAuthProvider: React.FC = ({ children }) => {
  const [data, setData] = useState<AuthState>(() => {
    const user = cookies.get(`@${REACT_APP_APP_NAME}:admin`);

    if (user) {
      return {
        user,
      };
    }
    return {} as AuthState;
  });

  const updateUser = useCallback(
    user => {
      setData({
        ...data,
        user: { ...data.user, ...user },
      });

      cookies.set(`@${REACT_APP_APP_NAME}:admin`, JSON.stringify(user), {
        path: '/',
      });
    },
    [data],
  );

  const signOut = useCallback(() => {
    cookies.remove(`@${REACT_APP_APP_NAME}:admin`);
    setData({} as AuthState);
  }, []);

  return (
    <AdminAuthContext.Provider
      value={{
        signOut,
        updateUser,
        user: data.user,
      }}
    >
      {children}
    </AdminAuthContext.Provider>
  );
};

export function useAdminAuth(): AdminAuthContextData {
  const context = useContext(AdminAuthContext);
  return context;
}
